module.exports = "pegasus_template/assets/arrow-up.png";